import { render, staticRenderFns } from "./TodoDrawer.vue?vue&type=template&id=0b43cc58"
import script from "./TodoDrawer.vue?vue&type=script&lang=js"
export * from "./TodoDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports